module.exports = new Promise(resolve => {
            const url = "https://ui-core.bprcasa.com/remoteEntry.js?t=" + Date.now();
            const script = document.createElement("script");
            script.src = url;

            script.onload = () => {
              const proxy = {
                get: (request) => window.ui_core.get(request),
                init: (arg) => {
                  try {
                    return window.ui_core.init(arg);
                  } catch (e) {}
                }
              };
              resolve(proxy);
            };

            document.head.appendChild(script);
          });